/*********************************************************************
 * 
 * WARNING: This shader class is automatically generated, any manual 
 * edits will be lost.
 * Last generated: 2020-04-03T14:33:08.723Z
 * 
 ********************************************************************/
import { ShaderBase } from '../ShaderBase';

export type VolumetricLightShaderUniforms = {
	uBlendTextureSampler: WebGLUniformLocation,
	uLightPosition: WebGLUniformLocation,
	uExposure: WebGLUniformLocation,
	uDecay: WebGLUniformLocation,
	uDensity: WebGLUniformLocation,
	uWeight: WebGLUniformLocation,
	uSamples: WebGLUniformLocation
};

export type VolumetricLightShaderAttributes = {
	aVertexPosition: number
};

export type VolumetricLightShaderSettings = string[];

export class VolumetricLightShader extends ShaderBase<VolumetricLightShaderUniforms, VolumetricLightShaderAttributes> {

    private static fragmentShaderSource = `
// https://github.com/react-spring/react-three-fiber/blob/master/examples/src/resources/shaders/VolumetricLightShader.js

varying vec2 vTextureCoord;
uniform sampler2D uBlendTextureSampler;

uniform vec2 uLightPosition;
uniform float uExposure;
uniform float uDecay;
uniform float uDensity;
uniform float uWeight;
uniform int uSamples;
const int MAX_SAMPLES = 100;

void main()
{
    vec2 texCoord = vTextureCoord;
    vec2 deltaTextCoord = texCoord - uLightPosition;
    deltaTextCoord *= 1.0 / float(uSamples) * uDensity;

    vec4 color = texture2D(uBlendTextureSampler, texCoord);

    float illuminationDecay = 1.0;
    for(int i = 0; i < MAX_SAMPLES; i++) {
        if(i == uSamples) break;

        texCoord -= deltaTextCoord;

        vec4 sample = texture2D(uBlendTextureSampler, texCoord);

        sample *= illuminationDecay * uWeight;
        color += sample;
        illuminationDecay *= uDecay;
    }
    gl_FragColor = color * uExposure;
}
`;

    private static vertexShaderSource = `
// xy = vertex position in normalized device coordinates ([-1,+1] range).
attribute vec2 aVertexPosition;

varying vec2 vTextureCoord;

const vec2 scale = vec2(0.5, 0.5);

void main()
{
    vTextureCoord  = aVertexPosition * scale + scale; // scale vertex attribute to [0,1] range
    gl_Position = vec4(aVertexPosition, 0.0, 1.0);
}
`;

    protected get warnAttributeMismatch(): boolean {
        return false;
    }
    constructor(gl: WebGLRenderingContext, settings: VolumetricLightShaderSettings) {
        super(gl, VolumetricLightShader.fragmentShaderSource, VolumetricLightShader.vertexShaderSource, settings);
    }

}
        